import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { TokenService } from './token.service';
import { ApiService } from './apiservice'; 
import { CustomerCallRecords } from '../app/interfaces/CustomerCallRecords';

@Injectable({
  providedIn: 'root'
})
export class CustomerCallRecordsService {
  url: string;
  urlUserFilter: string;
  apiToken: string = "";
  userId: string = "";
  userObject: any;

  constructor(private http: HttpClient, private tokenService: TokenService, private apiService: ApiService) { 
    this.url = environment.apiConfig.apiPath;
    this.urlUserFilter = environment.apiConfig.uri + environment.apiConfig.userIdFilter;
   // this.getTokenHeaders();   
  }

  public getUser() {
      return this.apiService.getUser();
  }

   getResult(payload: any) {
       return this.apiService.post(this.url + `api/CustomerCallRecords/GetAllCustomerCallRecords`, payload);
     }
}
